import React, { useState, useMemo, useEffect } from "react";
import { Tabs } from "antd";
import Layout from "../../components/Layout/Layout";
import LearningPaths from "../LearningPaths/LearningPaths";
import TrainingHistory from "../TrainingHistory/TrainingHistory";
import CoursesAndPlanification from "./Courses&Planification/CoursesAndPlanification";
import NewTrainingRequest from "./NewTrainingRequest.jsx"
import QuizManagement from '../QuizManagement/QuizManagement.jsx';
import EventsAndRequests from "./Events&Requests/EventsAndRequests.jsx";
import UserManagement from "../UserManagement/UserManagement.jsx";
import { useNavigate, useParams } from "react-router-dom";
import SkillsManagement from "./SkillsManagement/SkillsManagement.jsx";
import './AdminSpace.scss'
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle.jsx";
import Mouse from "../../components/Mouse/Mouse.jsx";
import ScrollTop from "../../components/ScrollTop/ScrollTop.jsx";

function AdminSpace() {

  const items = useMemo(
    () => [
      {
        key: "training-requests",
        label: "Training requests",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <NewTrainingRequest />
          </React.Suspense>
        ),
      },
      {
        key: "training-history",
        label: "Training History",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <TrainingHistory />
          </React.Suspense>
        ),
      },
      {
        key: "learning-paths",
        label: "Learning paths",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <LearningPaths />
          </React.Suspense>
        ),
      },
      {
        key: "courses-&-planification",
        label: "Courses & Planification",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <CoursesAndPlanification />
          </React.Suspense>
        ),
      },
      {
        key: "quiz-management",
        label: "Quiz Management",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <QuizManagement />
          </React.Suspense>
        ),
      },
      {
        key: "users-management",
        label: "Users Management",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <UserManagement />
          </React.Suspense>
        ),
      },
      {
        key: "skills-management",
        label: "Skills Management",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <SkillsManagement />
          </React.Suspense>
        ),
      },
      {
        key: "events",
        label: "Events",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <EventsAndRequests />
          </React.Suspense>
        ),
      },
    ],
    []
  );

  const getTab = (tab) => {
    if (tab === "training-requests" || tab === "training-history" || tab === "learning-paths" || tab === "courses-&-planification" || tab === "quiz-management" || tab === "users-management" || tab === "skills-management" || tab === "events") {
      return tab;
    } return "training-requests";
  };

  const refactorKey = (key) => {
    return key.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  }

  const navigate = useNavigate();
  const { tab } = useParams();
  const [name, setName] = useState((tab) => getTab(tab));

  const onChangeHeaderName = (key) => {
    navigate(`../adminspace/${key}`);
  };

  useEffect(() => {
    setName(refactorKey(getTab(tab)));
  }, [tab])

  return (
    <>
      <FlatTitle pageName={refactorKey(name)} />
      <div className="section-container">
        <div id="wrapper">
          <Tabs
            tabBarGutter={85}
            activeKey={getTab(tab)}
            items={items}
            onChange={onChangeHeaderName}
            className="custom-tabs"
            destroyInactiveTabPane={true}
          />
          <Mouse />
          <ScrollTop />
        </div>
      </div>
    </>
  );
}

export default AdminSpace;
